import { initialState } from ".";
import { IADPState } from ".";

export class AppStateProvider {
  static instance: AppStateProvider;
  private state: IADPState = initialState;

  static getInstance() {
    if (!this.instance) {
      this.instance = new AppStateProvider();
    }
    return this.instance;
  }

  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor() {}

  getState() {
    return { ...this.state };
  }

  // Should only ever be called by useLoggingReducer
  setState(newState: IADPState) {
    this.state = newState;
  }
}
